export default __webpack_public_path__ + "static/media/contact-bg.4ce21a54.png";